import React, { useState } from 'react';
import { LayoutTemplate, MousePointerClick } from 'lucide-react';

function SectionBlock({ s, i, isHero }) {
  return (
    <div className={`rounded-lg border p-3 ${isHero ? 'bg-[#0A0F1C] text-white border-[#0A0F1C]' : 'bg-white border-[#E2E8F0]'}`} data-testid={`blueprint-section-${i}`}>
      <div className={`text-[10px] font-bold uppercase tracking-[0.15em] mb-1 ${isHero ? 'text-[#F97316]' : 'text-[#94A3B8]'}`}>{i + 1}. {s.name}</div>
      <div className={`font-black leading-snug ${isHero ? 'text-lg' : 'text-sm text-[#0A0F1C]'}`}>{s.headline}</div>
      {s.subcopy && <p className={`text-xs mt-1 leading-relaxed ${isHero ? 'text-slate-300' : 'text-[#475569]'}`}>{s.subcopy}</p>}
      {s.cta && (
        <span className={`inline-flex items-center gap-1 mt-2 px-3 py-1 rounded-full text-[11px] font-bold ${isHero ? 'bg-[#F97316] text-white' : 'bg-[#EFF6FF] text-[#1D4ED8]'}`}>
          <MousePointerClick size={11} /> {s.cta}
        </span>
      )}
    </div>
  );
}

export default function WebsiteBlueprint({ blueprint }) {
  const pages = blueprint?.pages || [];
  const [tab, setTab] = useState(0);
  if (!pages.length) return null;
  const page = pages[Math.min(tab, pages.length - 1)];
  return (
    <div data-testid="website-blueprint">
      <div className="flex items-center gap-2 mb-2"><LayoutTemplate size={15} className="text-[#1D4ED8]" /><h5 className="font-bold text-sm text-[#0A0F1C]">Website layout concept</h5>
        <span className="text-[11px] text-[#94A3B8]">the best structure to convert visitors, page by page</span></div>
      <div className="flex flex-wrap gap-1.5 mb-3">
        {pages.map((p, i) => (
          <button key={`${p.name}-${i}`} type="button" onClick={() => setTab(i)} data-testid={`blueprint-tab-${i}`}
            className={`px-3 py-1 rounded-full text-xs font-bold border transition-colors ${tab === i ? 'bg-[#1D4ED8] text-white border-[#1D4ED8]' : 'bg-white text-[#475569] border-[#E2E8F0] hover:border-[#1D4ED8]'}`}>{p.name}</button>
        ))}
      </div>
      <div className="rounded-xl border border-dashed border-[#CBD5E1] bg-[#F8FAFC] p-3">
        {page.purpose && <p className="text-xs text-[#64748B] mb-2"><b>Purpose:</b> {page.purpose}</p>}
        <div className="space-y-2">{(page.sections || []).map((s, i) => <SectionBlock key={i} s={s} i={i} isHero={i === 0} />)}</div>
      </div>
    </div>
  );
}
